import * as THREE from 'three';
import {GLTFLoader} from 'three/addons/loaders/GLTFLoader.js';
import {OrbitControls} from 'three/addons/controls/OrbitControls.js';
import {RoomEnvironment} from 'three/addons/environments/RoomEnvironment.js';
const el=document.getElementById('three');
const renderer=new THREE.WebGLRenderer({antialias:true,alpha:true});
renderer.setSize(el.clientWidth,el.clientHeight); renderer.setPixelRatio(devicePixelRatio);
renderer.toneMapping=THREE.ACESFilmicToneMapping; renderer.toneMappingExposure=1.05;
renderer.shadowMap.enabled=true; renderer.shadowMap.type=THREE.PCFSoftShadowMap;
el.appendChild(renderer.domElement);
const scene=new THREE.Scene();
try{ const pmrem=new THREE.PMREMGenerator(renderer);
  scene.environment=pmrem.fromScene(new RoomEnvironment(),0.04).texture; }catch(e){console.warn('env skipped',e);}
const cam=new THREE.PerspectiveCamera(32,el.clientWidth/el.clientHeight,.01,10);
window.addEventListener('resize',()=>{ const w=el.clientWidth,h=el.clientHeight;
  if(w>0&&h>0){ cam.aspect=w/h; cam.updateProjectionMatrix(); renderer.setSize(w,h); } });
cam.position.set(0,.17,.5);
const ctl=new OrbitControls(cam,renderer.domElement); ctl.target.set(0,.14,0); ctl.enableDamping=true; ctl.minDistance=.25; ctl.maxDistance=.9;
scene.add(new THREE.HemisphereLight(0xfff6e8,0x555044,.55));
const d1=new THREE.DirectionalLight(0xffffff,.9); d1.position.set(.6,1,.8);
d1.castShadow=true; d1.shadow.mapSize.set(1024,1024);
d1.shadow.camera.left=-.25; d1.shadow.camera.right=.25;
d1.shadow.camera.top=.4; d1.shadow.camera.bottom=-.05;
d1.shadow.radius=4; scene.add(d1);
const d2=new THREE.DirectionalLight(0xcfe0ff,.25); d2.position.set(-.7,.4,-.6); scene.add(d2);
try{ const sh=new THREE.Mesh(new THREE.PlaneGeometry(.6,.6),
    new THREE.ShadowMaterial({opacity:0.28}));
  sh.rotation.x=-Math.PI/2; sh.position.y=.0003; sh.receiveShadow=true; scene.add(sh); }catch(e){}
const fc=document.getElementById('c');
const mirror=document.createElement('canvas'); mirror.width=fc.width; mirror.height=fc.height;
const tex=new THREE.CanvasTexture(mirror);
tex.flipY=true; tex.colorSpace=THREE.SRGBColorSpace; tex.anisotropy=8;
tex.repeat.set(600/615, 480/495); tex.offset.set(7.5/615, 7.5/495);   // crop bleed: show trim area only
function sizeIt(){ const w=el.clientWidth,h=el.clientHeight;
  if(w>0&&h>0){ cam.aspect=w/h; cam.updateProjectionMatrix(); renderer.setSize(w,h); } }
try{ new ResizeObserver(sizeIt).observe(el); }catch(e){}
sizeIt();
function initModel(buf){
  new GLTFLoader().parse(buf,'',g=>{
    scene.add(g.scene);
    let labelMat=null;
    g.scene.traverse(o=>{ if(!o.isMesh||!o.material)return;
      if(['Bourbon','Cork','WoodCap','Capsule','CapsuleTop','Label'].includes(o.material.name)) o.castShadow=true;
      if(o.material.name==='Label')labelMat=o.material;
      if(o.material.name==='Bourbon'&&o.material.map){
        // photoreal liquid (v6+): opaque amber gradient + view-angle darkening so edges read thicker
        const m=o.material; m.envMapIntensity=0.5; m.sheen=0.8;
        m.onBeforeCompile=sh=>{sh.fragmentShader=sh.fragmentShader.replace('#include <dithering_fragment>',
          'float fr=pow(1.0-abs(dot(normalize(vViewPosition),normal)),1.8); gl_FragColor.rgb*=mix(1.12,0.32,fr);\n#include <dithering_fragment>');};
        m.customProgramCacheKey=()=>'bourbonFresnel2'; m.needsUpdate=true;
      } else if(o.material.name==='Bourbon'){ // legacy transparent liquid
        o.material.depthWrite=false;o.renderOrder=1;o.material.envMapIntensity=0.18;o.material.needsUpdate=true; }
      if(o.material.name==='GlassBase'){o.material.depthWrite=false;o.renderOrder=0;}
      if(o.material.name==='Glass'){o.material.depthWrite=false;o.renderOrder=2;} });
    if(labelMat){ labelMat.map=tex; labelMat.color.set(0xffffff); labelMat.needsUpdate=true; }
    // auto-frame: the bourbon (0.29 m) sits at cam z .5 / target y .14; scale for taller bottles (wine .31, champagne .335)
    try{ const bb=new THREE.Box3().setFromObject(g.scene); const h=bb.max.y-bb.min.y; const k=h/0.29;
      ctl.target.set(0,.14*k,0); cam.position.set(0,.17*k,.5*k); ctl.minDistance=.25*k; ctl.maxDistance=.9*k; ctl.update(); }catch(e){}
    window.dirty=true;
  }, e=>console.error('LabelStudio 3D parse:', e));
}
function loadGLB(tries){
  fetch((window.LABEL_STUDIO_CONFIG||{}).glbUrl)
    .then(r=>{ if(!r.ok) throw new Error('GLB HTTP '+r.status); return r.arrayBuffer(); })
    .then(initModel)
    .catch(e=>{ console.error('LabelStudio 3D load:', e);
      if(tries>0) setTimeout(()=>loadGLB(tries-1), 900); });
}
loadGLB(4);
(function loop(){ requestAnimationFrame(loop);
  if(window.dirty!==false){
    if(window.__renderClean){ window.__renderClean(mirror); }
    else{ const x=mirror.getContext('2d'); x.clearRect(0,0,mirror.width,mirror.height); x.drawImage(fc,0,0); }
    tex.needsUpdate=true; window.dirty=false; }
  ctl.update();
  if(el.clientWidth>0) renderer.render(scene,cam); })();